<template>
    <div class="bg">
        <img src="@/assets/home/bgLeft.png" alt="" class="bgLeft">
        <img src="@/assets/home/bgRight.png" alt="" class="bgRight">
        <div class="page animate__animated  animate__fadeIn">
            <div class="spectrum">
                <div class="title">
                    SOLUTION
                    <h1>解决方案</h1>
                    <div>
                        <i></i> <i></i>
                    </div>
                </div>
            </div>
            <div>
                <spectrum-security-supervision-platform/>
            </div>
            <div :style="{height:pageWidth>1000?'170px':'60px'}"></div>
        </div>
    </div>
</template>

<script>
import SpectrumSecuritySupervisionPlatform from "./Platform2.vue";

export default {
    name: "Spectrum",
    components: {
        SpectrumSecuritySupervisionPlatform,
    },
    data() {
        return {
            key: 1,
            pageWidth: window.innerWidth
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.pageWidth = window.innerWidth;
        }
    }
}
</script>

<style scoped lang="less">
@import "../../../styles/spectrum/index";
</style>
